// assets
import { FundOutlined, SettingOutlined } from '@ant-design/icons';

// icons
const icons = {
  FundOutlined,
  SettingOutlined
};

// ==============================|| MENU ITEMS - MARKETING ||============================== //

const marketing = {
  id: 'marketing',
  title: 'Marketing & Promo',
  type: 'group',
  // Intero gruppo nascosto a cassieri (anche voci senza roles ereditano il gate in NavGroup).
  roles: ['admin', 'ufficio'],
  children: [
    {
      id: 'campaign-manager',
      title: 'Gestione Campagne',
      type: 'item',
      url: '/marketing/campaigns',
      icon: icons.FundOutlined,
      roles: ['admin', 'ufficio']
    },
    {
      id: 'promo-analytics',
      title: 'Analytics Promo',
      type: 'item',
      url: '/marketing/analytics',
      icon: icons.SettingOutlined,
      roles: ['admin', 'ufficio']
    }
  ]
};

export default marketing;
